import { OrderModel, OrderPost } from '../models/Order'
import { getFunciton, postWithoutTokenFunciton } from 'utils/ApiHelper'

import axios from 'axios'


export async function refreshOrder(channel_id:string) {
  const res: any = await getFunciton(`video/refresh?channel_id=`+channel_id)
  return res
}
export async function listHistory() {
  const apiAlias = window.apiAlias || 'subscribe'
  const res: any = await getFunciton(`${apiAlias}/listHistory`)
  return res
}
export async function listHistorySubsribe(from: string, to: string, user_id: number) {

  const res: any = await getFunciton(`subscribe/listHistory?from=${from}&to=${to}&user_id=${user_id}`)
  return res

}
export async function listHistoryByChannelID(channel_id: string) {
  const res: any = await getFunciton(`subscribe/listHistory?channel_id=${channel_id}`)
  return res
}

export async function deleteHistoryError() {
  const apiAlias = window.apiAlias || 'subscribe'
  const res: any = await getFunciton(`${apiAlias}/deleteHistoryError`)
  return res
}

export async function getMyPoints() {
  const res: any = await getFunciton('user/my-list-point')
  return res
}
export async function getPoints(user_id: number) {
  const res: any = await getFunciton('user/list-point/' + user_id)
  return res
}
export async function getSetting() {
  try{
    const res: any = await getFunciton(`admin/setting`)
    return res
  } catch(ex) {
    console.log(ex);
  }
}

export async function getListKeyGoogle() {
  try{
    const res: any = await getFunciton(`admin/key-google/listAll`);
    return res;
  } catch(ex) {
    console.log(ex);
  }
}

export async function updateKeyGoogle(id: any,data: any) {
  try{
    const res: any = await postWithoutTokenFunciton(`admin/key-google/update/${id}`, data);
    return res;
  } catch(ex) {
    console.log(ex);
  }
}

export async function makeKeyGoogle(data: any) {
  try {
    const res: any = await postWithoutTokenFunciton(`admin/key-google/make`, data);
    return res;
  } catch(ex) {
    console.log(ex);
  }
}

export async function getListGroups() {
  const apiAlias = window.apiAlias || 'subscribe'
  const res: any = await getFunciton(`/subscribe/getGroups`)
  return res
}

export async function updateSetting(setting: any) {
  const res: any = await postWithoutTokenFunciton('admin/setting', setting)
  return res
}

export async function updateOrder(order: OrderModel) {
  const apiAlias = window.apiAlias || 'subscribe'
  const res: any = await postWithoutTokenFunciton(`${apiAlias}/update`, order)
  return res
}

export async function addOrder(channel_id:string) {
  const res: any = await getFunciton(`video/insert?channel_id=${channel_id}`)
  return res
}

export async function addOrderMulti(order: OrderPost[]) {
  const apiAlias = window.apiAlias || 'subscribe'
  const res: any = await postWithoutTokenFunciton(`${apiAlias}/insertMulti`, order)
  return res
}

export async function addGroup(groupName: string) {
  const apiAlias = window.apiAlias || 'subscribe'
  const res: any = await postWithoutTokenFunciton(`/${apiAlias}/insertGroup`, {
    name: groupName,
  })
  return res
}

export async function deleteGroup(id: number) {
  const apiAlias = window.apiAlias || 'subscribe'
  const res: any = await getFunciton(`/${apiAlias}/deleteGroup?id=` + id)
  return res
}

export async function deleteChannel(channel_id: string) {
    return await getFunciton(`/video/delete?channel_id=` + channel_id)
}

export async function confirmCancelChannel(channel_id: string, refund: number) {
  return await getFunciton(`/subscribe/confirmCancel?channel_id=` + channel_id + "&refund=" + refund)
}

export async function cancelChannel(channel_id: string) {
  return await getFunciton(`/subscribe/cancelChannel?channel_id=` + channel_id)
}
export async function restoreChannel(order_id: number) {
  return await getFunciton(`/subscribe/restoreChannel?order_id=` + order_id)
}

export async function listComputer() {
  return await getFunciton('computer/list')
}

export async function getReports(from: string, to: string, type: string) {
  if (type === 'like') {
    return await getFunciton('/data/reportLike?from=' + from + '&to=' + to)
  }
  return await getFunciton('/data/report?from=' + from + '&to=' + to)
}

export async function deleteComputer(computer: string) {
  return await getFunciton('/computer/delete?computer='+computer)
}